import PropTypes from 'prop-types';
// @mui
import {
  Table,
  TableBody,
  TableContainer,
  TableRow,
  TableCell,
  Box,
  CircularProgress,
  Typography,
} from '@mui/material';
import TableHead from '@mui/material/TableHead';

const SUM_UP_COLUMNS = [
  { id: 'cash', label: 'Cash ($)' },
  { id: 'stripe_link', label: 'Stripe Link ($)' },
  { id: 'stripe_terminal', label: 'Stripe Terminal ($)' },
  { id: 'bog_terminal', label: 'BOG Terminal ($)' },
  { id: 'bank_transfer', label: 'Bank Transfer ($)' },
  { id: 'check', label: 'Check ($)' },
  { id: 'pay_later', label: 'Unpaid ($)' },
  { id: 'weight', label: 'Total Weight (KG)' },
];

const ROW_LABELS = {
  NEW: 'Registered at selected date',
  OLD: 'Registered before selected date',
  TOTAL: 'Total',
};

export default function GeorgianPhysicalPaymentTotalsTable({ data, loading }) {
  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 3 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!data) {
    return (
      <Box sx={{ py: 3, textAlign: 'center' }}>
        <Typography variant="body2" color="text.secondary">
          No data for this period
        </Typography>
      </Box>
    );
  }

  return (
    <TableContainer>
      <Table size="medium">
        <TableHead>
          <TableRow>
            <TableCell />
            {SUM_UP_COLUMNS.map((col) => (
              <TableCell key={col.id}>{col.label}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell component="th" scope="row" sx={{ fontWeight: 600 }}>
              {ROW_LABELS.NEW}
            </TableCell>
            {SUM_UP_COLUMNS.map((col) => (
              <TableCell key={col.id}>{data.new_groups_payment?.[col.id] ?? '—'}</TableCell>
            ))}
          </TableRow>
          <TableRow>
            <TableCell component="th" scope="row" sx={{ fontWeight: 600 }}>
              {ROW_LABELS.OLD}
            </TableCell>
            {SUM_UP_COLUMNS.map((col) => (
              <TableCell key={col.id}>{data.old_groups_payment?.[col.id] ?? '—'}</TableCell>
            ))}
          </TableRow>
          <TableRow>
            <TableCell component="th" scope="row" sx={{ fontWeight: 600 }}>
              {ROW_LABELS.TOTAL}
            </TableCell>
            {SUM_UP_COLUMNS.map((col) => (
              <TableCell key={col.id}>{data.total?.[col.id] ?? '—'}</TableCell>
            ))}
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}

GeorgianPhysicalPaymentTotalsTable.propTypes = {
  data: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.object),
    PropTypes.object,
  ]),
  loading: PropTypes.bool,
};